(function () {
  'use strict';

  var html = document.documentElement;
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function lock() {
    var sbw = window.innerWidth - html.clientWidth;
    if (sbw > 0) html.style.setProperty('--pk-sbw', sbw + 'px');
    html.classList.add('pk-rv-lock');
  }
  function unlock() {
    html.classList.remove('pk-rv-lock');
    html.style.removeProperty('--pk-sbw');
  }

  // Leftover lock (e.g. the theme editor re-rendered the section while the dialog was open).
  if (!document.querySelector('.pk-rvm[open]')) unlock();

  var roots = document.querySelectorAll('.pk-rv:not([data-pk-ready])');
  for (var r = 0; r < roots.length; r++) init(roots[r]);

  function init(root) {
    root.setAttribute('data-pk-ready', '');

    var track = root.querySelector('.pk-rv-track');
    var prevBtn = root.querySelector('.pk-rv-nav--prev');
    var nextBtn = root.querySelector('.pk-rv-nav--next');
    var bar = root.querySelector('.pk-rv-progress span');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.pk-rv-card'));

    /* ---------- Carousel ---------- */
    function isRtl() { return getComputedStyle(track).direction === 'rtl'; }

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      var pos = Math.abs(track.scrollLeft);
      root.classList.toggle('is-static', max <= 2);
      if (prevBtn) prevBtn.disabled = pos <= 2;
      if (nextBtn) nextBtn.disabled = pos >= max - 2;
      if (bar && max > 2) {
        var w = track.clientWidth / track.scrollWidth * 100;
        var off = (pos / max) * (100 - w);
        var rtl = isRtl();
        bar.style.width = w + '%';
        bar.style[rtl ? 'right' : 'left'] = off + '%';
        bar.style[rtl ? 'left' : 'right'] = 'auto';
      }
    }

    function pageBy(dir) {
      var item = track.querySelector('.pk-rv-item');
      if (!item) return;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      var step = item.getBoundingClientRect().width + gap;
      var visible = Math.max(1, Math.floor(track.clientWidth / step));
      track.scrollBy({ left: dir * (isRtl() ? -1 : 1) * step * visible, behavior: 'smooth' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { pageBy(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { pageBy(1); });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; sync(); });
    }, { passive: true });

    if ('ResizeObserver' in window) new ResizeObserver(function () { sync(); }).observe(track);
    else window.addEventListener('resize', sync);
    sync();

    /* ---------- Dialog ---------- */
    var dlg = root.querySelector('.pk-rvm');
    if (!dlg) return;
    var q = function (sel) { return dlg.querySelector(sel); };
    var el = {
      panel: q('.pk-rvm-panel'), body: q('.pk-rvm-body'), media: q('.pk-rvm-media'),
      bg: q('.pk-rvm-bg'), img: q('.pk-rvm-img'), close: q('.pk-rvm-close'),
      avatar: q('.pk-rvm-avatar'), name: q('.pk-rvm-name__text'), date: q('.pk-rvm-date'),
      stars: q('.pk-rvm-stars'), score: q('.pk-rvm-score'),
      quote: q('.pk-rvm-quote'), text: q('.pk-rvm-text'),
      prod: q('.pk-rvm-prod'), prodImg: q('.pk-rvm-prod img'), prodName: q('.pk-rvm-prod strong'),
      ig: q('.pk-rvm-ig'), pager: q('.pk-rvm-pager'), count: q('.pk-rvm-count'),
      prev: q('.pk-rvm-step--prev'), next: q('.pk-rvm-step--next')
    };
    var index = -1, closing = false, pressTarget = null;

    function textOf(card, sel) {
      var n = card.querySelector(sel);
      return n ? n.textContent.trim() : '';
    }
    function initial(name) {
      var s = name.replace(/^[@\s]+/, '');
      return (Array.from(s)[0] || '★').toUpperCase();
    }

    function fill(i) {
      var card = cards[i], d = card.dataset;
      var name = textOf(card, '.pk-rv-name__text');
      var body = textOf(card, '.pk-rv-text');
      var date = textOf(card, '.pk-rv-date');

      el.avatar.textContent = initial(name);
      el.name.textContent = name;
      el.date.textContent = date;
      el.date.hidden = !date;

      var rating = parseFloat(d.rating);
      if (isNaN(rating)) rating = 5;
      rating = Math.max(0, Math.min(5, rating));
      el.stars.style.setProperty('--pk-rating', rating);
      el.stars.setAttribute('aria-label', 'דירוג ' + rating + ' מתוך 5');
      el.score.textContent = rating.toFixed(1);

      el.text.textContent = body;
      el.text.classList.toggle('is-short', body.length > 0 && body.length <= 110);
      el.quote.hidden = !body;

      // Image: show the already loaded thumbnail instantly, then swap to the large one.
      var hasImg = !!d.img;
      el.media.hidden = !hasImg;
      el.panel.classList.toggle('is-text', !hasImg);
      if (hasImg) {
        var thumb = card.querySelector('.pk-rv-img');
        var first = (thumb && (thumb.currentSrc || thumb.src)) || d.img;
        el.img.src = first;
        el.bg.src = first;
        el.img.alt = 'תמונה מתוך הביקורת של ' + name;
        if (first !== d.img) {
          var hi = new Image();
          hi.onload = function () { if (index === i) { el.img.src = d.img; el.bg.src = d.img; } };
          hi.src = d.img;
        }
      }

      var showProd = !!(d.product && d.productUrl && d.productCurrent !== 'true');
      el.prod.hidden = !showProd;
      if (showProd) {
        el.prod.href = d.productUrl;
        el.prodName.textContent = d.product;
        el.prodImg.hidden = !d.productImg;
        if (d.productImg) el.prodImg.src = d.productImg;
      }

      var igOk = /^https?:\/\//i.test(d.igUrl || '');
      el.ig.hidden = !igOk;
      if (igOk) el.ig.href = d.igUrl;

      el.pager.hidden = cards.length < 2;
      el.count.textContent = (i + 1) + ' מתוך ' + cards.length;
      el.prev.disabled = i <= 0;
      el.next.disabled = i >= cards.length - 1;

      el.body.scrollTop = 0;
    }

    function open(i) {
      if (i < 0) return;
      index = i;
      closing = false;
      dlg.classList.remove('is-closing');
      fill(i);
      if (dlg.open) return;
      lock();
      if (typeof dlg.showModal === 'function') dlg.showModal();
      else { dlg.setAttribute('open', ''); dlg.classList.add('is-fallback'); }
    }

    function step(dir) {
      var n = index + dir;
      if (n < 0 || n >= cards.length) return;
      index = n;
      fill(n);
      el.panel.classList.remove('is-swap');
      void el.panel.offsetWidth;
      el.panel.classList.add('is-swap');
    }

    function onClosed() {
      unlock();
      dlg.classList.remove('is-fallback');
      var btn = cards[index] && cards[index].querySelector('.pk-rv-open');
      if (btn) btn.focus();
    }
    function finish() {
      closing = false;
      dlg.classList.remove('is-closing');
      if (typeof dlg.close === 'function') dlg.close();
      else { dlg.removeAttribute('open'); onClosed(); }
    }
    function close() {
      if (!dlg.open && !dlg.hasAttribute('open')) return;
      if (closing) return;
      if (reduceMotion) { finish(); return; }
      closing = true;
      dlg.classList.add('is-closing');
      setTimeout(finish, 210);
    }

    track.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.pk-rv-open') : null;
      if (btn) open(cards.indexOf(btn.closest('.pk-rv-card')));
    });
    el.close.addEventListener('click', close);
    el.prev.addEventListener('click', function () { step(-1); });
    el.next.addEventListener('click', function () { step(1); });

    dlg.addEventListener('close', onClosed);
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); close(); });
    // Close on backdrop click, but not when a text selection drag ends outside the panel.
    dlg.addEventListener('pointerdown', function (e) { pressTarget = e.target; });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg && pressTarget === dlg) close();
    });
    dlg.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var rtl = getComputedStyle(dlg).direction === 'rtl';
      step((e.key === 'ArrowLeft') === rtl ? 1 : -1);
      e.preventDefault();
    });
  }
})();
